<div>
  <table mat-table [dataSource]="dataSource" aria-describedby="mydesc" aria-describedby="mydesc">
    <ng-container matColumnDef="sourceName">
      <th class=" " id="channelName" mat-header-cell *matHeaderCellDef>Channel</th>
      <td mat-cell *matCellDef="let element; let index = index">
        <ng-container *ngIf="!element.isEditable">
          {{ element.sourceName }}
        </ng-container>
        <ng-container *ngIf="element.isEditable">
          <span *ngIf="afterEdit; else dispName">
            <mat-form-field class="example-full-width" style="width: 130px">
              <mat-select
                [formControl]="getControl(index, 'sourceName')"
                name="channel"
                [(ngModel)]="element.sourceName"
                [value]="element.sourceName"
                (selectionChange)="channelSelect($event, index)"
              >
                <mat-option *ngFor="let item of channel" [value]="item.sourceName">{{ item.sourceName }}</mat-option>
              </mat-select>
              <mat-error *ngIf="getControl(index, 'sourceName').hasError('required')">
                Field is
                <strong>required</strong>
              </mat-error>
            </mat-form-field>
          </span>
          <ng-template #dispName>{{ element.sourceName }}</ng-template>
        </ng-container>
      </td>
    </ng-container>
    <ng-container matColumnDef="refrenceCode">
      <th class=" " id="referenceCode" mat-header-cell *matHeaderCellDef>Reference Code</th>
      <td mat-cell *matCellDef="let element; let index = index">
        {{ element.referenceCode }}
      </td>
    </ng-container>
    <ng-container matColumnDef="startDate">
      <th class=" " id="startDate" mat-header-cell *matHeaderCellDef>Start Date</th>

      <td mat-cell *matCellDef="let element; let index = index">
        <ng-container *ngIf="element.hasOwnProperty('startDate')">
          <ng-container *ngIf="!element.isEditable">
            {{ element.startDate }}
          </ng-container>
          <ng-container *ngIf="element.isEditable">
            <span *ngIf="afterEdit; else dispDate">
              <mat-form-field class="example-full-width">
                <input
                  matInput
                  [matDatepicker]="picker"
                  name="startDate"
                  [value]="getControl(index, 'startDate').value"
                  [min]="startDate"
                  [max]="endDate"
                  [formControl]="getControl(index, 'startDate')"
                  (dateChange)="orgValueChange(getControl(index, 'startDate'))"
                  (click)="picker.open()"
                  readonly
                />
                <mat-datepicker-toggle matSuffix [for]="picker">
                  <mat-icon matDatepickerToggleIcon>
                    <img
                      id="calendarImg"
                      src="assets/images/icons/default_icons/icon-calendar.png"
                      alt="icon-calendar"
                    />
                  </mat-icon>
                </mat-datepicker-toggle>
                <mat-datepicker #picker touchUi></mat-datepicker>
                <mat-hint></mat-hint>
                <mat-error *ngIf="getControl(index, 'startDate').hasError('required')">
                  Field is
                  <strong>required</strong>
                </mat-error>
              </mat-form-field>
            </span>
            <ng-template #dispDate>{{ element.startDate }}</ng-template>
          </ng-container>
        </ng-container>
      </td>
    </ng-container>
    <ng-container matColumnDef="endDate">
      <th class=" " id="endDate" mat-header-cell *matHeaderCellDef>End Date</th>
      <td mat-cell *matCellDef="let element; let index = index">
        <ng-container *ngIf="element.hasOwnProperty('endDate')">
          <ng-container *ngIf="!element.isEditable">
            {{ element.endDate }}
          </ng-container>
          <ng-container *ngIf="element.isEditable">
            <mat-form-field class="example-full-width">
              <input
                matInput
                [matDatepicker]="picker"
                name="endDate"
                [min]="minDate"
                [max]="endDate"
                [formControl]="getControl(index, 'endDate')"
                (click)="picker.open()"
                readonly
              />
              <mat-datepicker-toggle matSuffix [for]="picker">
                <mat-icon matDatepickerToggleIcon>
                  <img id="calendarImg" src="assets/images/icons/default_icons/icon-calendar.png" alt="icon-calendar" />
                </mat-icon>
              </mat-datepicker-toggle>
              <mat-datepicker #picker touchUi></mat-datepicker>
              <mat-hint></mat-hint>
              <mat-error *ngIf="getControl(index, 'endDate').hasError('required')">
                Field is
                <strong>required</strong>
              </mat-error>
            </mat-form-field>
          </ng-container>
        </ng-container>
      </td>
    </ng-container>
    <ng-container matColumnDef="hotJob">
      <th class=" " id="hotJob" mat-header-cell *matHeaderCellDef>Hot Job</th>
      <td mat-cell *matCellDef="let element; let index = index">
        <ng-container *ngIf="element.hasOwnProperty('hotJob')">
          <ng-container *ngIf="!element.isEditable && element.publicationId != 0">
            <mat-checkbox [disabled]="viemMode" [formControl]="getControl(index, 'hotJob')" name="hotJob">
            </mat-checkbox>
          </ng-container>
          <ng-container *ngIf="element.isEditable">
            <mat-checkbox
              [disabled]="viemMode"
              [formControl]="getControl(index, 'hotJob')"
              name="hotJob"
              (change)="hotJobVal = !hotJobVal"
              (change)="hotJobCheck(index)"
            >
            </mat-checkbox>
          </ng-container>
        </ng-container>
      </td>
    </ng-container>
    <ng-container matColumnDef="hotJobDays">
      <th class=" " id="hotJobDays" mat-header-cell *matHeaderCellDef>Hot Job Days</th>
      <td mat-cell *matCellDef="let element; let index = index">
        <ng-container *ngIf="element.hasOwnProperty('hotJobDays')">
          <ng-container *ngIf="!element.isEditable">
            {{ element.hotJobDays }}
          </ng-container>
          <ng-container *ngIf="element.isEditable">
            <mat-form-field class="example-full-width">
              <input matInput [formControl]="getControl(index, 'hotJobDays')" name="hotJobDays" />
              <mat-error *ngIf="getControl(index, 'hotJobDays').hasError('required')">
                Field is
                <strong>required</strong>
              </mat-error>
            </mat-form-field>
          </ng-container>
        </ng-container>
      </td>
    </ng-container>
    <ng-container matColumnDef="status">
      <th class=" " id="status" mat-header-cell *matHeaderCellDef>Status</th>
      <td mat-cell *matCellDef="let element; let index = index">
        <ng-container *ngIf="element.hasOwnProperty('status')">
          {{ element.status }}
        </ng-container>
      </td>
    </ng-container>
    <ng-container matColumnDef="Edit/Delete">
      <th class=" " id="actionButtons" mat-header-cell *matHeaderCellDef></th>
      <mat-cell *cdkCellDef="let element; let index = index">
        <ng-container *ngIf="element.hasOwnProperty('status')">
          <ng-container *ngIf="element.isEditable">
            <a *ngIf="!viemMode" (click)="update1(index, element)" class="edit_posting">
              <img
                class="add_attach_publication"
                id="updateImg"
                src="assets/images/icons/default_icons/icon-tick-dark.png"
                alt="icon-tick"
              />
            </a>
            <a *ngIf="!viemMode" (click)="closeUpdate(index, element)" class="edit_posting">
              <img
                class="add_attach_publication"
                id="closeImg"
                src="assets/images/icons/default_icons/icon-close.png"
                alt="icon-close"
              />
            </a>
          </ng-container>
          <ng-container *ngIf="!element.isEditable && element.status !== 'Withdrawn' && element.publicationId != 0">
            <a *ngIf="!viemMode" (click)="edit(index, element)" [class.disabled]="editDisable" class="edit_posting">
              <img
                class="add_attach_publication"
                id="editImg"
                src="assets/images/icons/default_icons/icon-edit.png"
                alt="icon-edit"
              />
            </a>
            <a *ngIf="!viemMode" class="edit_posting" (click)="deleteRow(index)">
              <img
                class="add_attach_publication"
                id="deleteImg"
                src="assets/images/icons/default_icons/icon-delete-mini.png"
                alt="icon-delete"
              />
            </a>
          </ng-container>
        </ng-container>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="Add">
      <th class=" " mat-header-cell id="secondaryActionButton" *matHeaderCellDef></th>
      <mat-cell *cdkCellDef="let element; let index = index">
        <ng-container *ngIf="!element.hasOwnProperty('status')">
          <a *ngIf="!viemMode" class="edit_posting mat-plus-i" (click)="addSecondarySource(index, element)">
            <img
              class="add_attach_publication"
              id="addSecondaryImg"
              src="assets/images/icons/purple_icons/icon-add-dark.png"
              alt="icon-add"
            />
          </a>
        </ng-container>
        <ng-container *ngIf="element.publicationId == 0">
          <a *ngIf="!viemMode" class="edit_posting mat-plus-i" (click)="addSecondarySource(index, element)">
            <img
              class="add_attach_publication"
              id="addSecondaryImg"
              src="assets/images/icons/purple_icons/icon-add-dark.png"
              alt="icon-add"
            />
          </a>
        </ng-container>
      </mat-cell>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns" class="mat-elevation-z1 tr_bottom"></tr>
  </table>

  <button
    mat-flat-button
    class="Icon-Btn mtb10"
    name="btnAddNewPostingChannel"
    (click)="addTableRow()"
    *ngIf="!viemMode"
  >
    <img class="add_button" id="addImg" src="assets/images/icons/purple_icons/icon-add-dark.png" alt="icon-add" />
    <span>Add New Posting Channel</span>
  </button>
  <div *ngIf="errorMessageId" class="pad8">
    <span class="errorMessage">Posting Channel Table is Mandatory</span>
  </div>
</div>
